module.exports = __webpack_public_path__ + "img/product-six-0.99158bac.png";